import { useState } from 'react';
import { Link } from 'react-router-dom';

import { Button, Drawer, EmptyState, Icon, IconButton } from '../ui/index.js';
import { useNotifications } from '../lib/notifications.js';
import { relativeTime } from '../lib/format.js';

/** The nav bell: shows an unread count and opens the notifications drawer. */
export function NotificationsBell() {
  const { items, unreadCount, markRead, markAllRead } = useNotifications();
  const [open, setOpen] = useState(false);

  return (
    <div className="pt-bell">
      <IconButton
        label={unreadCount > 0 ? `Notifications, ${unreadCount} new` : 'Notifications'}
        icon={<Icon name="bell" size={22} />}
        onClick={() => setOpen(true)}
      />
      {unreadCount > 0 ? (
        <span className="pt-bell__count" aria-hidden="true">
          {unreadCount > 9 ? '9+' : unreadCount}
        </span>
      ) : null}

      <Drawer open={open} onClose={() => setOpen(false)} title="Notifications" side="right">
        {items.length === 0 ? (
          <EmptyState
            icon="bell"
            title="You are all caught up"
            body="News about your projects and your team shows up here."
          />
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--pt-space-2)' }}>
            {unreadCount > 0 ? (
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button variant="ghost" size="sm" onClick={markAllRead}>
                  Mark all as read
                </Button>
              </div>
            ) : null}
            {items.map((n) => {
              const inner = (
                <>
                  {!n.readAt ? <span className="pt-notif__dot" aria-hidden="true" /> : null}
                  <div className="pt-notif__body">
                    <div>{n.body}</div>
                    <div className="pt-notif__time">{relativeTime(n.createdAt)}</div>
                  </div>
                </>
              );
              const className = ['pt-notif', n.readAt ? '' : 'pt-notif--unread'].filter(Boolean).join(' ');
              return n.href ? (
                <Link
                  key={n.id}
                  to={n.href}
                  className={className}
                  onClick={() => {
                    markRead(n.id);
                    setOpen(false);
                  }}
                >
                  {inner}
                </Link>
              ) : (
                <button
                  key={n.id}
                  type="button"
                  className={className}
                  style={{ textAlign: 'left', cursor: 'pointer' }}
                  onClick={() => markRead(n.id)}
                >
                  {inner}
                </button>
              );
            })}
          </div>
        )}
      </Drawer>
    </div>
  );
}
